import React from 'react';
import { windowStore } from 'util/windowStore';
import { updateApiBaseUrl } from 'util/Api/config';
import { cacheKey } from 'appConstants';

export const useUpdateApiPathFromCachedCloudEnv = () => {
  React.useEffect(() => {
    let cloudEnvironment = windowStore.get(cacheKey.CLOUD_ENV);
    if (!cloudEnvironment) {
      // Direct URL path for password reset may include cloud_environment in the qsp
      const [, urlFragments] = location.hash.split('?');
      const queryParams = urlFragments ? Object.fromEntries(new URLSearchParams(urlFragments)) : {};
      cloudEnvironment = queryParams.cloud_environment;
    }
    updateApiBaseUrl(cloudEnvironment, true);
  }, []);
};
